export default {
  // Api
  api: {
    error: '当前服务异常，请稍后再试',
  },
  // 布局
  layout: {
    base: {
      declare: '©2021 XGIMI. All Rights Reserved.',
    },
  },
  // 页面
  page: {
    test: {
      toast: '提示',
    },
    feedback: {
      title: '反馈问题',
      history: '历史反馈',
      error1: '请先选择问题类型',
      error2: '请填写详情描述',
      error3: '详情描述最多填写500字哦',
      type: '问题类型',
      pickType: '选择问题类型',
      detailDescribe: '详细描述',
      placeholder: '请写下您的建议，我们会努力改进',
      gotoHistory: '查看历史反馈',
      submit: '提交',
      machine: '投影仪相关',
      app: '极米APP相关',
      historyEmpty: '暂无反馈内容',
      welcome: '欢迎反馈您的问题和建议',
      gotoFeed: '去反馈',
      replied: '已回复',
      noReply: '未回复',
      success: '提交成功',
      thanks: '感谢您的反馈！',
      bottom: '我是有底线的',
      lowVersion: 'APP版本过低',
      upgrade: '请升级到最新版本',
      goToUpgrade: '去升级',
    },
  },
  // 组件
  component: {
    userCenter: {
      login: '登录',
      logout: '退出',
    },
  },
};
